/* eslint eqeqeq: off */
import React, {Component} from "react";
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import 'ag-grid-enterprise';
import Group, {GroupDescription, GroupHead} from "../../../Components/Group";
import Button from "../../../Components/Control/Button";
import './index.css';
import Grid, {GridButton, GridControls, gridDateTime, GridState, GridStates} from "../../../Components/Grid";
import {ModalAction} from "../../../Components/Modal";
import Resource from "../../../Resource";
import moment from "jalali-moment";
import Prompt, {PromptControl} from "../../../Components/Prompt";
import ModalPrint from "../../Modal/ModalPrint";
import {printerTemplate} from "../../../Printer";
import {Tool} from "../../../App";
import Notif from "../../../Components/Notif";
import {connect} from "react-redux";
import ModalWashRequest from "../../Modal/ModalWashRequest";
import {SectionNormRequest} from '../../../Server/NormRequest';
import {SectionWashRequest} from '../../../Server/WashRequest';
import Perms from '../../../Perms';

class PageSectionWashRequests extends Component {
    constructor(props) {
        super(props);

        if (!Perms().SECTION_WASH_REQUESTS.VIEW)
            props.history.push(Resource.ROUTE.HOME);

        this.state = {
            grid: {
                columnDefs: [{
                    field: 'patientFileCode',
                    headerName: 'شماره پرونده',
                    headerTooltip: 'شماره پرونده',
                    checkboxSelection: true,
                    headerCheckboxSelection: true,
                    filter: 'agTextColumnFilter'
                }, {
                    field: 'createDateTime',
                    headerName: 'اعتبار درخواست',
                    headerTooltip: 'اعتبار درخواست',
                    valueGetter: row => {
                        const diff = moment().diff(moment(row.data.createDateTime), 'hour');
                        if (diff >= 72)
                            return 'منقضی شده';
                        else if (diff > 48)
                            return 'کمتر از 24 ساعت';
                        else if (diff > 24)
                            return '24 تا 48 ساعت';
                        else
                            return 'بیش از 48 ساعت';
                    },
                    cellRenderer: row => {
                        const diff = moment().diff(moment(row.data.createDateTime), 'hour');
                        return diff > 72 ? 'منقضی شده' : `${72 - diff} ساعت`;
                    }
                }, {
                    headerName: 'اطلاعات بیمار',
                    children: [{
                        field: 'patientFullName',
                        headerName: 'نام بیمار',
                        headerTooltip: 'نام بیمار'
                    }, {
                        field: 'patientNationalCode',
                        headerName: 'کد‌ملی',
                        headerTooltip: 'کد‌ملی'
                    }, {
                        field: 'patientBloodGroupStr',
                        headerName: 'BGRh بیمار',
                        headerTooltip: 'BGRh بیمار',
                        cellRenderer: row => row.data.patientBloodGroupStr || '-',
                        cellClass: 'green'
                    }]
                }, {
                    headerName: 'اطلاعات درخواست',
                    children: [{
                        field: 'sectionStr',
                        headerName: 'بخش درخواست کننده',
                        headerTooltip: 'بخش درخواست کننده'
                    }]
                }, {
                    headerName: 'اطلاعات تایید درخواست',
                    children: [{
                        field: 'confirmFullName',
                        headerName: 'متصدی',
                        headerTooltip: 'متصدی',
                        cellRenderer: row => row.data.confirmFullName || '-'
                    }, {
                        field: 'confirmDateTime',
                        headerName: 'زمان تایید',
                        headerTooltip: 'زمان تایید',
                        valueGetter: gridDateTime.bind(this, 'date'),
                        cellRenderer: gridDateTime
                    }]
                }, {
                    headerName: 'وضعیت',
                    headerTooltip: 'وضعیت',
                    pinned: props.gridDefaultSettings.pinStatusColumn,
                    sortable: false,
                    enableRowGroup: false,
                    cellRenderer: 'state',
                    valueGetter: row => row.data.statusStr
                }, {
                    headerName: 'عملیات',
                    headerTooltip: 'عملیات',
                    pinned: props.gridDefaultSettings.pinOperationColumn,
                    sortable: false,
                    filter: false,
                    minWidth: 158,
                    hide: !(Perms().SECTION_WASH_REQUESTS.UPDATE || Perms().SECTION_WASH_REQUESTS.DELETE),
                    enableRowGroup: false,
                    cellRenderer: 'control'
                }],
                frameworkComponents: {
                    state: row => {
                        const colors = {20: 'yellow', 22: 'red', 23: 'green'};

                        return <GridStates>
                            <GridState theme={colors[row.data.statusId]}>{row.data.statusStr}</GridState>
                        </GridStates>;
                    },
                    control: row => {
                        const expired = moment().diff(moment(row.data.createDateTime), 'hour') > 72;

                        return <GridControls>
                            {Perms().SECTION_WASH_REQUESTS.UPDATE && !expired && <GridButton type={"button"} theme={'edit'} title={'ویرایش'} onClick={this.update.bind(this, row.data)}/>}
                            <GridButton type={"button"} theme={'view'} title={'مشاهده'} onClick={this.view.bind(this, row.data)}/>
                            {Perms().SECTION_WASH_REQUESTS.DELETE && !expired && <GridButton type={"button"} theme={'delete'} title={'حذف'} onClick={this.del.bind(this, row.data)}/>}
                        </GridControls>;
                    }
                },
                getContextMenuItems: params => {
                    if (params.node) {
                        const diff = moment().diff(moment(params.node.data.createDateTime), 'hour') > 72;

                        return [{
                            name: 'ویرایش فرم درخواست خون شسته',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.EDIT1.BLACK}" alt="">`,
                            action: this.update.bind(this, params.node.data),
                            disabled: diff || !Perms().SECTION_WASH_REQUESTS.UPDATE
                        }, {
                            name: 'مشاهده درخواست فرآورده',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.EYE.BLACK}" alt="">`,
                            action: this.view.bind(this, params.node.data)
                        }, {
                            name: 'حذف درخواست فرآورده',
                            icon: `<img class="GridContextMenuItem" src="${Resource.IMAGE.PACK.TRASH1.BLACK}" alt="">`,
                            action: this.del.bind(this, params.node.data),
                            disabled: diff || !Perms().SECTION_WASH_REQUESTS.DELETE
                        },
                            'separator',
                            ...params.defaultItems];
                    }
                },
                onRowDoubleClicked: row => {
                    const expired = moment().diff(moment(row.data.createDateTime), 'hour') > 72;

                    if (!expired)
                        this.ref.modalSectionWashRequest.current.open(row.data, ModalAction.VIEW);
                },
                help: _ => {
                    return <div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>نکته:</h3>
                                <p>درخواست فرآورده از سمت بخش بعد از ثبت تنها 72 ساعت در چرخه فعالیت سامانه اعتبار دارد و بعد از آن به حالت منقضی در می آید.</p>
                                <p>جهت اطلاع از مدت زمان باقی مانده اعتبار درخواست در سامانه می توانید به ستون اعتبار درخواست مراجعه کنید.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>رنگ‌ها:</h3>
                                <p className={'help-back-gre mar-b-4'}>نشان دهنده گروه خونی بیمار می باشد.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>وضعیت‌ها:</h3>
                                <p><GridState theme={"yellow"}>در انتظار تایید</GridState> درخواست از سمت بانک خون در حال بررسی می باشد و بایستی منتظر تایید و یا رد درخواست بمانید.</p>
                            </div>
                        </div>
                        <div className={'Help-block'}>
                            <div className={'pad-10 fb-20 dis-f'}>
                                <h3 className={'help-title'}>عملیات:</h3>
                                <p><GridButton theme={'edit'} title={'ویرایش'}/> درصورت نیاز به ویرایش اطلاعات درخواست قبل از تایید توسط بانک خون می توانید از این طریق اقدام کنید.</p>
                                {/*<p><GridButton theme={'delete'} title={'حذف'}/> درصورت نیاز به حذف درخواست قبل از تایید توسط بانک خون می توانید از این طریق اقدام کنید.</p>*/}
                            </div>
                        </div>
                    </div>;
                }
            },
            rowData: [],
            selectedRows: [],
            gridContext: null
        };

        this.ref = {
            grid: React.createRef(),
            prompt: React.createRef(),
            print: React.createRef(),
            modalSectionWashRequest: React.createRef()
        };
    }

    componentDidMount() {
        const {state, props} = this;

        const grid = Tool.applyGridDefaultSettings(props.gridDefaultSettings, state.grid);

        if (grid) {
            this.setState({grid});
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        return this.state.grid !== nextState.grid ||
            this.state.rowData !== nextState.rowData;
    }

    render() {
        return <React.Fragment>
            <Group className={'PageSectionWashRequests-group mar-10'}>
                <GroupHead title={'درخواست‌های خون شسته'}>
                    <Button className={'mar-e-8'} theme={'blue'} onClick={this.addRequestClickHandler.bind(this)}>ثبت درخواست خون شسته</Button>
                </GroupHead>
                <GroupDescription>لیست فرآورده‌های درخواست شده از این قسمت قابل مشاهده می باشد.</GroupDescription>
                <Grid  refer={this.ref.grid} id={'sectionWashRequests'} {...this.state.grid} rowData={this.state.rowData} onGridReady={this.gridReadyHandler.bind(this)} onSelectionChanged={this.gridSelectionHandler.bind(this)}/>
            </Group>
            <Prompt ref={this.ref.prompt}/>
            <ModalPrint refer={this.ref.print}/>
            <ModalWashRequest refer={this.ref.modalSectionWashRequest} onSuccess={this.updateGrid.bind(this)}/>
        </React.Fragment>;
    }

    updateGrid() {
        this.ref.grid.current.loading();

        SectionWashRequest.list()
            .then(list => {
                this.ref.grid.current.loading(false);

                this.setState({rowData: list});
            })
            .catch(message => {
                this.ref.grid.current.error();
            });
    }

    gridReadyHandler(params) {
        this.updateGrid();

        this.setState({gridContext: params});
    }

    gridSelectionHandler(rows) {
        this.setState({selectedRows: rows});
    }

    addRequestClickHandler() {
        this.ref.modalSectionWashRequest.current.open({}, ModalAction.INSERT);
    }

    del(row, props = {loading: _ => null}) {
        this.ref.prompt.current.open({
            title: 'اخطار',
            description: 'آیا می خواهید درخواست مورد نظر را حذف کنید؟',
            buttons: PromptControl.YES_NO,
            onClose: button => {
                if (button.id === PromptControl.YES) {
                    props.loading();
                    SectionWashRequest.delete({
                        sectionRequestId: row?.sectionRequestId
                    }).then(_ => {
                        this.updateGrid();

                        new Notif(Resource.STRING.FETCH.DELETE_SUCCESSFUL).show();

                        props.loading(false);
                    }).catch(message => {
                        props.loading(false);

                        new Notif({message, theme: 'error'}).show();
                    });
                }
            }
        });
    }

    print(row, props = {loading: _ => null}) {
        const printModal = this.ref.print.current;
        props.loading();

        if (row.formTypeId == 1) {
            SectionNormRequest.data({sectionNormRequestId: row.sectionRequestId})
                .then(data => {
                    props.loading(false);

                    printModal.open({
                        title: 'چاپ مجدد',
                        prints: [{
                            id: 'sectionNormRequestForm',
                            title: 'چاپ فرم درخواست',
                            count: 1,
                            template: printerTemplate.INSERT_NORM_REQUEST,
                            parameters: {
                                PatientFirstName: data?.patientFirstName,
                                PatientLastName: data?.patientLastName,
                                PatientFatherName: data?.patientFatherName,
                                PatientBirthDate: data?.patientBirthDate,
                                PatientNationalCode: data?.patientNationalCode,
                                PatientGenderId: data?.patientGenderId,
                                PatientProvinceStr: data?.patientProvinceStr,
                                PatientCityStr: data?.patientCityStr,
                                HospitalNameStr: this.props.user?.hospitalFullName || '-',
                                SectionStr: data?.sectionStr,
                                PatientFileCode: data?.patientFileCode,
                                InjectionHistory: data?.injectionHistory,
                                PregnancyHistory: data?.pregnancyHistory,
                                ComplicationsHistory: data?.complicationsHistory,
                                AntiBodyHistory: data?.antiBodyHistory,
                                MedicationPrescribeNeed: data?.medicationPrescribeNeed,
                                MedicationName: data?.medicationName,
                                HowToPrescribe: data?.howToPrescribe,
                                PatientDiagnosticStr: data?.patientDiagnosticStr,
                                DiseaseCauseId: data?.diseaseCauseId,
                                SurgeryTypeStr: data?.surgeryTypeStr,
                                DiseaseCauseOtherReason: data?.diseaseCauseOtherReason,
                                HemoglobinAmount: data?.hemoglobinAmount,
                                Pltamount: data?.pltamount,
                                PatientBloodGroupStr: data?.patientBloodGroupStr,
                                Rbccount: data?.rbccount,
                                Lrbccount: data?.lrbccount,
                                PediatricCount: data?.pediatricCount,
                                WashedRbccount: data?.washedRbccount,
                                WashedTime: data?.washedTime,
                                OtherProductsCount: data?.otherProductsCount,
                                OtherProductsName: data?.otherProductsName,
                                Wbcount: data?.wbcount,
                                Ffpcount: data?.ffpcount,
                                Crycount: data?.crycount,
                                Cppcount: data?.cppcount,
                                Pltcount: data?.pltcount,
                                RequestPurpose: data?.requestPurpose,
                                NeedDate: moment(data?.needDate).format('jYYYY/jMM/jDD'),
                                InjectionVelocity: data?.injectionVelocity,
                                Rhtest: data?.rhtest,
                                AntiBodyTest: data?.antiBodyTest,
                                CrossMatchTest: data?.crossMatchTest,
                                DocterName: data?.docterName,
                                RequestDate: data?.requestDate ? moment(data?.requestDate).format('jYYYY/jMM/jDD') : null,
                                TermsAndConditions: data?.termsAndConditions,
                                Sampler: data?.sampler,
                                SamplerName: data?.samplerName,
                                SamplerLastName: data?.samplerLastName,
                                BloodSamplingDate: data?.bloodSamplingDate ? moment(data?.bloodSamplingDate).format('jYYYY/jMM/jDD') : null,
                                BloodSamplingTime: data?.bloodSamplingTime ? moment(data?.bloodSamplingTime).format('HH:mm') : null
                            }
                        }, {
                            id: 'normRequestSamplingLabel',
                            title: 'چاپ برچسب نمونه گیری',
                            count: 1,
                            template: printerTemplate.NORM_REQUEST_SAMPLING_LABEL,
                            parameters: {
                                PFullName: `${data?.patientFirstName} ${data?.patientLastName}`,
                                PFileCodeStr: data?.patientFileCode,
                                SamplingDateTime: moment(data?.bloodSamplingDate).format('jYYYY/jMM/jDD HH:mm'),
                                SamplerFullName: `${data?.samplerName} ${data?.samplerLastName}`
                            }
                        }]
                    });
                })
                .catch(message => {
                    props.loading(false);

                    new Notif({message, theme: 'error'}).show();
                });
        } else if (row.formTypeId == 2) {
        }
    }

    update(row) {
        this.ref.modalSectionWashRequest.current.open(row, ModalAction.UPDATE);
    }

    view(row) {
        this.ref.modalSectionWashRequest.current.open(row, ModalAction.VIEW);
    }
}

const mapStateToProps = state => {
    return {
        user: state.user,
        gridDefaultSettings: state.grid.defaultSettings
    };
};

export default connect(mapStateToProps)(PageSectionWashRequests);